import React from 'react';

import Box from '@mui/material/Box';

interface Props {
    ref: React.Ref<HTMLDivElement>;
}

const AxisSelectForm = ({ ref, children }: React.PropsWithChildren<Props>) => {
    const firstChild = React.Children.toArray(children).at(0);
    const lastChild = React.Children.toArray(children).at(-1);
    return (
        <Box sx={{ width: '100%', ml: -1 }} display="flex">
            {firstChild}
            <Box ref={ref} flexGrow={1}></Box>
            {lastChild}
        </Box>
    );
};

export default AxisSelectForm;
